import ApiService from '../index'

const qs = require('qs')

export const users = async (query) => {
  const URI = `/api/user?${qs.stringify(query)}`

  const response = await ApiService.get(URI)

  const users = response.data.map((line) => {
    line.hover = false
    return line
  })

  return users
}

export const toggleStatus = async (id) => {
  const URI = `/api/user/desative/${id}`

  const response = await ApiService.post(URI, {})

  return response
}

export const deleteUser = async (id) => {
  const URI = `/api/user/${id}`

  const response = await ApiService.delete(URI)

  return response
}

export const addUser = async (user) => {
  const URI = `/api/user`

  const response = await ApiService.post(URI, user)

  return response.data
}

export const updateUser = async (user) => {
  const URI = `/api/user/${user.id}`

  const response = await ApiService.patch(URI, user)

  return response.data
}

// USER FORM

// mounted () {
//   this.getComdominiums()
//   this.getProfiles()
// },
